import { typeOfGoods as typeOfGoodsColors } from './colorSchemes'

export const typeOfGoods = {
  colors: typeOfGoodsColors,
}
